export default class Tabbox {
	constructor(element) {

		this.tablist = element.querySelectorAll('[role="tablist"]')[0];
		this.tabs = element.querySelectorAll('[role="tab"]');
		this.panels = element.querySelectorAll('[role="tabpanel"]');

		if(this.tablist === undefined || this.tabs.length !== this.panels.length) {
			throw 'Tabbox markup is not complete';
		}

		if(this.tabs.length <= 0){
			return
		}

		this.panels[0].classList.add('active');
		this.tabs[0].classList.add('active');
		for(let i = 0; i < this.tabs.length; i++){
			this.tabs[i].addEventListener('click', () => {
				this.togglePanel(this.panels[i])
				this.toggleTab(this.tabs[i])
			})

            let address = this.tabs[i].getAttribute("data-address");

            if(address !== null && address === window.location.hash.substring(1)) {
                this.tabs[i].click();
                element.scrollIntoView({block: "start", behavior: "smooth"})
            }
		}

		this.restructureMarkup()
		window.dispatchEvent(new Event('redraw'));
	}

	togglePanel(panel){
		this.unfocusAllPanels()
		if(!panel.classList.contains('active')){
			panel.classList.add('active')
		}
	}
	unfocusAllPanels(){
		this.panels.forEach(panel => {
			if(panel.classList.contains('active')){
				panel.classList.remove('active')
			}
		})
	}

	toggleTab(tab){
		this.unfocusAllTabs()
		if(!tab.classList.contains('active')){
			tab.classList.add('active')
		}

		/* Redraw element when visible to show controls */
		let hiddenCheck = setInterval(() => {
			if(tab.style.display !== 'none') {
				window.dispatchEvent(new Event('redraw'))
				clearInterval(hiddenCheck);
			}
		}, 50)

		let address = tab.getAttribute("data-address");
		if(address !== null) {
		    window.location.hash = address;
        }
	}

	unfocusAllTabs(){
		this.tabs.forEach(tab => {
			if(tab.classList.contains('active')){
				tab.classList.remove('active')
			}
		})
	}

	/**
	 * This puts the controls in a container so that the component is wcag compliant
	 */
	restructureMarkup() {
		this.tabs.forEach(tab => {
			this.tablist.appendChild(tab)
		})
	}
}
